// Google Analytics utility functions
import { getUserToken } from './tokenTracking';

// Track page views
export const trackPageView = (pageName, pageTitle) => {
  if (typeof window !== 'undefined' && window.gtag) {
    const userToken = getUserToken();
    const configParams = {
      page_title: pageTitle,
      page_location: window.location.href,
      page_path: window.location.pathname,
    };

    // Add user token if available
    if (userToken) {
      configParams.user_token = userToken;
    }

    window.gtag('config', 'G-0TG2DKZS9J', configParams);

    // Custom event for page view
    const eventParams = {
      page_title: pageTitle,
      page_location: window.location.href,
      page_path: window.location.pathname,
      custom_parameter: pageName,
    };

    // Add user token to event if available
    if (userToken) {
      eventParams.user_token = userToken;
    }

    window.gtag('event', 'page_view', eventParams);
  }
};

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    const userToken = getUserToken();
    const eventParams = { ...parameters };

    // Add user token to all events if available
    if (userToken) {
      eventParams.user_token = userToken;
      // Debug log in development
      if (process.env.NODE_ENV === 'development') {
        console.log(`📊 Sending event "${eventName}" with user_token:`, userToken);
      }
    } else {
      // Debug log when token is missing
      if (process.env.NODE_ENV === 'development') {
        console.warn(`⚠️ Event "${eventName}" sent without user_token`);
      }
    }

    window.gtag('event', eventName, eventParams);
  }
};

// Track project page views
export const trackProjectView = (projectName, projectCategory) => {
  trackEvent('project_view', {
    project_name: projectName,
    project_category: projectCategory,
    page_type: 'project',
  });
};

// Track category navigation
export const trackCategoryNavigation = (categoryName) => {
  trackEvent('category_navigation', {
    category_name: categoryName,
    page_type: 'home',
  });
};

// Track image lightbox usage
export const trackImageLightbox = (imageName, projectName) => {
  trackEvent('image_lightbox_open', {
    image_name: imageName,
    project_name: projectName,
    interaction_type: 'image_view',
  });
};

// Track contact form interactions
export const trackContactInteraction = (interactionType) => {
  trackEvent('contact_interaction', {
    interaction_type: interactionType,
    page_type: 'contact',
  });
};

// Track navigation clicks
export const trackNavigationClick = (navigationType, destination) => {
  trackEvent('navigation_click', {
    navigation_type: navigationType,
    destination: destination,
  });
};
